/** Brief 12, K3 - Hisobotlar. */
export const ruB12Reports = {
  "reports12.title": "Отчёты",
  "reports12.myTitle": "Мой отчёт",
  "reports12.allBranches": "Все филиалы",
  "reports12.period": "Период",
  "reports12.period.hafta": "Неделя",
  "reports12.period.oy": "Месяц",
  "reports12.period.chorak": "Квартал",
  "reports12.quarterMeta": "{from}–{to}",
  "reports12.excel": "Excel",
  "reports12.excelDone": "{file} загружен",
  "reports12.excelFailed": "Не удалось получить файл Excel. Попробуйте ещё раз.",
  "reports12.tabs": "Разделы отчётов",
  "reports12.more": "Другие отчёты",
  "reports12.currency": "Валюта",
  "reports12.loading": "Отчёт формируется…",
  "reports12.empty.title": "Для отчёта мало данных",
  "reports12.empty.message": "Отчёт строится минимум по 7 дням сделок и обращений.",
  "reports12.empty.action": "К сделкам",
  "reports12.error.title": "Отчёт не загрузился",
  "reports12.denied": "Роль «{role}» не видит этот раздел. Если нужно, напишите владельцу агентства.",
  "reports12.denied.home": "На главную",
  "reports12.kpiGroup": "Показатели отчёта",
  "reports12.floor": "нужно минимум {count}",
  "reports12.late": "просрочено: {count}",
  "reports12.points": "п.п.",
  "reports12.previousPeriod": "к прошлому периоду",
  "reports12.mln": "{value} млн сум",

  "reports12.kpi.revenue": "Доход",
  "reports12.kpi.sales": "Продажи",
  "reports12.kpi.average_check": "Средний чек",
  "reports12.kpi.conversion": "Конверсия",
  "reports12.kpi.active_operators": "Активные операторы",
  "reports12.kpi.response": "Средний ответ",
  "reports12.kpi.firstResponse": "Средний первый ответ",
  "reports12.kpi.sla": "SLA выполнен",
  "reports12.kpi.unanswered": "Без ответа",
  "reports12.kpi.leads": "Обращения",
  "reports12.kpi.telegram_share": "Telegram",
  "reports12.kpi.instagram_share": "Instagram",
  "reports12.kpi.best_source": "Лучшая конверсия",
  "reports12.kpi.cash": "Поступления",
  "reports12.kpi.margin": "Маржа",
  "reports12.kpi.margin_percent": "Средняя маржа",
  "reports12.kpi.debts": "Долг клиентов",

  "reports12.chart.sales": "Доход",
  "reports12.chart.operators": "Закрытые сделки",
  "reports12.chart.sources": "Обращения",
  "reports12.chart.finance": "Маржа",
  "reports12.chart.personal": "Мои продажи",
  "reports12.step.hafta": "по дням",
  "reports12.step.oy": "по 5 дней",
  "reports12.step.chorak": "по месяцам",

  "reports12.table.branchOperators": "Филиалы и операторы",
  "reports12.table.operators": "По операторам",
  "reports12.table.destinations": "По направлениям",
  "reports12.table.sources": "По источникам",
  "reports12.table.vendors": "Маржа по туроператорам",
  "reports12.table.deals": "Закрытые сделки",
  "reports12.table.empty": "За этот период записей нет",
  "reports12.col.operator": "Оператор",
  "reports12.col.branch": "Филиал",
  "reports12.col.sales": "Продажи",
  "reports12.col.conversion": "Конверсия",
  "reports12.col.response": "Ответ",
  "reports12.col.sla": "SLA",
  "reports12.col.destination": "Направление",
  "reports12.col.revenue": "Доход",
  "reports12.col.average": "Средний чек",
  "reports12.col.source": "Источник",
  "reports12.col.leads": "Обращения",
  "reports12.col.vendor": "Туроператор",
  "reports12.col.bookings": "Брони",
  "reports12.col.turnover": "Оборот",
  "reports12.col.margin": "Маржа",
  "reports12.col.marginPercent": "Маржа, %",
  "reports12.col.deal": "Сделка",
  "reports12.col.client": "Клиент",
  "reports12.col.amount": "Сумма",
  "reports12.dealNumber": "№{id}",

  "reports12.loss.title": "Причины потерь",
  "reports12.loss.meta": "Из причин закрытия чатов и потери сделок · {count}",
  "reports12.count": "{count}",

  "reports12.portrait.line": "{period} · лидов: {leads}, броней: {booked}",
  "reports12.portrait.ai": "Вывод",
  "reports12.portrait.who.hafta": "Основной клиент прошлой недели",
  "reports12.portrait.who.oy": "Основной клиент прошлого месяца",
  "reports12.portrait.who.chorak": "Основной клиент прошлого квартала",
  "reports12.portrait.smallBase": "Данных мало, вывод приблизительный.",
  "reports12.portrait.budget": "Распределение бюджета",
  "reports12.portrait.otherBudgets": "Бюджет в другой валюте: {count}, не учтено",
  "reports12.portrait.destinations": "Топ направлений",
  "reports12.portrait.party": "С кем едут",
  "reports12.portrait.channels": "Канал",
  "reports12.portrait.months": "Месяц поездки",
  "reports12.portrait.monthsMeta": "на какой месяц бронируют",
  "reports12.portrait.noData": "Недостаточно данных",
  "reports12.portrait.monthsHint": "Для месяца поездки нужны брони минимум за 30 дней. Выберите период «Месяц».",

  "reports12.band.under_1000": "до $1 000",
  "reports12.band.to_1500": "$1 000–1 500",
  "reports12.band.to_2500": "$1 500–2 500",
  "reports12.band.to_4000": "$2 500–4 000",
  "reports12.band.over_4000": "более $4 000",
  "reports12.party.family": "Семья с детьми",
  "reports12.party.couple": "Пара",
  "reports12.party.friends": "Друзья",
  "reports12.party.solo": "Один",
  "reports12.party.corporate": "Корпоратив",

  "reports12.day.0": "Пн",
  "reports12.day.1": "Вт",
  "reports12.day.2": "Ср",
  "reports12.day.3": "Чт",
  "reports12.day.4": "Пт",
  "reports12.day.5": "Сб",
  "reports12.day.6": "Вс",
  "reports12.month.1": "Янв",
  "reports12.month.2": "Фев",
  "reports12.month.3": "Мар",
  "reports12.month.4": "Апр",
  "reports12.month.5": "Май",
  "reports12.month.6": "Июн",
  "reports12.month.7": "Июл",
  "reports12.month.8": "Авг",
  "reports12.month.9": "Сен",
  "reports12.month.10": "Окт",
  "reports12.month.11": "Ноя",
  "reports12.month.12": "Дек",
  "reports12.monthName.1": "Январь",
  "reports12.monthName.2": "Февраль",
  "reports12.monthName.3": "Март",
  "reports12.monthName.4": "Апрель",
  "reports12.monthName.5": "Май",
  "reports12.monthName.6": "Июнь",
  "reports12.monthName.7": "Июль",
  "reports12.monthName.8": "Август",
  "reports12.monthName.9": "Сентябрь",
  "reports12.monthName.10": "Октябрь",
  "reports12.monthName.11": "Ноябрь",
  "reports12.monthName.12": "Декабрь",

  "reports12.tab.sales": "Продажи",
  "reports12.tab.operators": "Операторы",
  "reports12.tab.sources": "Источники",
  "reports12.tab.finance": "Финансы",
  "reports12.tab.portrait": "Портрет клиентов",
  "reports12.tab.dynamics": "Приход и расход",
  "reports12.tab.operatorsDetail": "Операторы: деньги и вклад",
  "reports12.tab.leads": "Лиды",
  "reports12.tab.funnel": "Воронка",
  "reports12.tab.channels": "Источники лидов",
  "reports12.tab.responses": "Скорость ответа",
  "reports12.tab.margin": "Маржа",
  "reports12.tab.debtors": "Должники",
  "reports12.tab.ai": "AI",
  "reports12.tab.custdev": "Месячный CustDev",
  "reports12.tab.branches": "Филиалы",
};
